export default __webpack_public_path__ + "static/media/ngocduong.f2a9adc7.png";